import { faDesktop, faMobile, faQuestionCircle, faTablet } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Breadcrumb } from '@feathr/blackbox';
import { Chip } from '@feathr/components';

interface IProps {
  breadcrumb: Breadcrumb;
}

function DeviceChip({ breadcrumb }: IProps) {
  const { t } = useTranslation();

  const screenWidth = breadcrumb.get('s_w');
  const platform = breadcrumb.get('pform');
  let deviceLabel = t('Desktop');
  let deviceIcon = faDesktop;
  if (!screenWidth) {
    deviceLabel = t('Unknown');
    deviceIcon = faQuestionCircle;
  } else if (['android', 'iphone', 'ipad'].includes(platform)) {
    if (screenWidth > 480) {
      deviceLabel = t('Tablet');
      deviceIcon = faTablet;
    } else {
      deviceLabel = t('Mobile');
      deviceIcon = faMobile;
    }
  } else if (['macos', 'linux'].includes(platform)) {
    deviceLabel = t('Desktop');
    deviceIcon = faDesktop;
  } else if (screenWidth <= 768 && screenWidth > 480) {
    deviceLabel = t('Tablet');
    deviceIcon = faTablet;
  } else if (screenWidth <= 480) {
    deviceLabel = t('Mobile');
    deviceIcon = faMobile;
  }
  return <Chip prefix={<FontAwesomeIcon icon={deviceIcon} />}>{deviceLabel}</Chip>;
}

export default observer(DeviceChip);
